import React, { useState } from 'react';
import '../App.css';
import './Contact.css';
import Popup from '../components/Popup';
import { apiBaseUrl } from '../config/api';
import PageSections from '../site-content/PageSections';
import { useSitePage } from '../site/useSitePage';

function Contact() {
  const site = useSitePage('contact');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSending, setIsSending] = useState(false);
  const [popup, setPopup] = useState({
    isOpen: false,
    title: '',
    message: '',
    variant: 'success'
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    try {
      const res = await fetch(`${apiBaseUrl}/api/contact/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.detail || 'Fehler');
      }
      setPopup({
        isOpen: true,
        title: 'Nachricht gesendet',
        message: `Vielen Dank für deine Nachricht, ${formData.name}!\n\nWir melden uns so schnell wie möglich bei dir.`,
        variant: 'success'
      });
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (err) {
      setPopup({
        isOpen: true,
        title: 'Senden fehlgeschlagen',
        message: err.message || 'Deine Nachricht konnte nicht gesendet werden. Bitte versuche es erneut.',
        variant: 'error'
      });
    } finally {
      setIsSending(false);
    }
  };

  if (site.status === 'loading') return <div className="page-hero" aria-hidden="true" />;
  const sections = site.status === 'ready' ? site.sections : undefined;
  const pageSections = site.status === 'ready' ? sections : undefined;

  const form = (
            <div className="contact-form-section">
              <h2>Nachricht senden</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label htmlFor="email">E-Mail *</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Telefon</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Betreff *</label>
                  <select id="subject" name="subject" value={formData.subject} onChange={handleChange} required>
                    <option value="">Bitte wählen</option>
                    <option value="westernreiten">Westernreiten</option>
                    <option value="line-dance">Line Dance</option>
                    <option value="events">Events</option>
                    <option value="allgemein">Allgemeine Anfrage</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Nachricht *</label>
                  <textarea id="message" name="message" rows="6" value={formData.message} onChange={handleChange} required />
                </div>
                <button type="submit" className="btn btn-primary" disabled={isSending}>
                  {isSending ? 'Senden...' : 'Nachricht senden'}
                </button>
              </form>
            </div>
  );

  return (
    <>
      <Popup
        isOpen={popup.isOpen}
        title={popup.title}
        message={popup.message}
        variant={popup.variant}
        onClose={() => setPopup((prev) => ({ ...prev, isOpen: false }))}
      />
      <PageSections slug="contact" sections={pageSections} only={['hero']} />
      <section className="content-section">
        <div className="container">
          <div className="contact-wrapper">
            <PageSections slug="contact" sections={pageSections} only={['details']} />
            {form}
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
